import { render, staticRenderFns } from "./User.vue?vue&type=template&id=3ff23f52&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
import style0 from "./User.vue?vue&type=style&index=0&id=3ff23f52&prod&lang=scss&scoped=true"
import style1 from "./User.vue?vue&type=style&index=1&id=3ff23f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff23f52",
  null
  
)

export default component.exports